import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ChevronRightIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <polygon points="7.35 17.6 6.45 16.8 12.49 10.01 6.26 3.21 7.14 2.4 14.11 9.99 7.35 17.6"/>
            <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)"/>
        </SvgIcon>
    );
};
